import React from 'react';
import fintorroLogo from '../assets/fintorro-logo.png'; // update path if needed

const BookACall = () => {
  return (
    <>
      {/* Google Fonts for Nunito Sans */}
      <link
        href="https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400;600;700&display=swap"
        rel="stylesheet"
      />

      {/* Logo at absolute top */}
      <div style={{ textAlign: 'center', paddingTop: '0rem' }}>
        <img
          src={fintorroLogo}
          alt="FinTorro Logo"
          style={{ height: '120px', objectFit: 'contain' }}
        />
      </div>

      <div style={{ backgroundColor: '#fff', minHeight: '100vh', fontFamily: "'Nunito Sans', sans-serif" }}>
        <div style={{ padding: '1rem', maxWidth: '1200px', margin: '0 auto' }}>

          {/* Heading */}
          <h1 style={{
            fontSize: '38px',
            color: '#FF7C24',
            fontWeight: '700',
            textAlign: 'center',
            marginTop: '1.5rem',
            marginBottom: '1rem',
            lineHeight: '1.3'
          }}>
            Book a 1-on-1 Call with Prav
          </h1>

          {/* Subheadings */}
<p style={{
  fontSize: '24px',
  color: '#232830',
  textAlign: 'center',
  maxWidth: '850px',
  margin: '0 auto',
  backgroundColor: '#FFF3EB',
  padding: '1rem 1.5rem',
  borderRadius: '10px',
  fontWeight: 500
}}>
  Got feedback, ideas, or stuck somewhere?
</p>

<p style={{
  fontSize: '24px',
  color: '#232830',
  textAlign: 'center',
  maxWidth: '850px',
  margin: '1rem auto 2rem',
  backgroundColor: '#FFF3EB',
  padding: '1rem 1.5rem',
  borderRadius: '10px',
  fontWeight: 500
}}>
  Choose a time that works best for you using the calendar below — I’d love to hear your thoughts!
</p>

          {/* Full Calendly Embed for Direct Booking */}
          <div style={{
            width: '100%',
            height: '820px',
            margin: '0 auto',
            borderRadius: '12px',
            overflow: 'hidden',
            boxShadow: '0 0 15px rgba(0,0,0,0.05)'
          }}>
            <iframe
              src="https://calendly.com/prav-fintorro/30min?hide_event_type_details=1&hide_gdpr_banner=1"
              width="100%"
              height="100%"
              frameBorder="0"
              title="Book a Call with Prav"
              style={{ border: 'none' }}
              allow="fullscreen"
            ></iframe>
          </div>

        </div>
      </div>
    </>
  );
};

export default BookACall;
